<template>
  <div class="main">
    <div class="main_left">
      <ul class="main_tabs">
        <li :style="info.titleStyle" @click="moreClick(info)">
          {{ info.title }}
        </li>

        <li
          :style="info.recommendStyle"
          v-for="item in info.recommendList"
          :key="item.id"
          @click="movieClick(item, info)"
        >
          {{ item.name }}
        </li>
        <li
          :class="moreClass"
          :style="info.titleBtnStyle"
          @click="moreClick(info)"
        >
          {{ sHrefText }}
        </li>
        <!-- <ul>
          <li
            v-for="item in info.button"
            :key="item.name"
            @click="btnClick(item)"
          >
            <i>
              <img
                :src="item.icon"
                :style="item.iconStyle"
                class="buttonIcon"
              />
            </i>
            <span :style="item.style">{{ item.name }}</span>
          </li>
        </ul> -->
      </ul>

      <ul
        class="main_list"
        :style="info.isSeniority ? 'justify-content: space-between;' : ''"
      >
        <li
          v-show="!!item"
          v-for="(item, idx) in mainList"
          :style="!!item ? item.style : ''"
          :key="idx"
        >
          <img :src="item.img" @click="movieClick(item, info)" />
          <span class="total" v-if="!!item.total" :style="info.totalStyle">{{
            item.total
          }}</span>

          <span
            class="title"
            :style="info.nameStyle"
            @click="movieClick(item, info)"
            v-if="isContent"
            >{{ item.name }}</span
          >
          <span class="synopsis" :style="info.introStyle">{{
            item.intro
          }}</span>
        </li>
      </ul>
    </div>

    <div
      class="main_right"
      v-if="!!info.list && info.list.length > 0 && info.isSeniority"
    >
      <div class="main_tabs">TOP榜</div>

      <Seniority :info="info.seniorityInfo" @movieClick="seniorityClick" />
      <!-- <li>
          <span>1</span>
          <span>都市之修行千年</span>
        </li>
        <li>
          <span>2</span>
          <span>双面千金洛莞莞</span>
        </li>
        <li>
          <span>3</span>
          <span>对手过家家</span>
        </li>
        <li>
          <span>4</span>
          <span>我的非凡父母_国语版</span>
        </li>
        <li>
          <span>5</span>
          <span>地球最后的夜晚</span>
        </li> -->
    </div>
  </div>
</template>

<style lang="scss" scoped>
* {
  text-align: left;
}
.imageList {
  display: block;
  /*width: 100%;*/
  position: relative;
}
.title {
  padding: 20px 40px;
  text-align: left;
  box-sizing: border-box;
  position: relative;
}
.total {
  position: absolute;
  bottom: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.4);
  color: #fff;
  padding: 5px 10px;
  border-radius: 10px;
}
.title > img {
  width: 27px;
  height: 27px;
  position: absolute;
  top: 50%;
  left: 0px;
  transform: translate(0, -50%);
}
.title > ul {
  float: right;
}
.title > ul > li {
  list-style: none;
  cursor: pointer;
}
.title > b {
  font-size: 24px;
}
.title > span {
  padding: 0px 20px;
  font-size: 15px;
  color: black;
  cursor: pointer;
}
.title > span.vip {
  color: #3fb1af;
}
.title > .recommend {
  display: inline-block;
  margin-right: 8px;
  font-size: 15px;
  color: #a7a7a7;
  padding: 3px 12px;
  border-radius: 10px;
  border: solid 1px #a7a7a7;
  box-sizing: border-box;
}
.content {
  box-sizing: border-box;
}
.margin_r {
  margin-right: 10px;
}
.movieImage {
  display: inline-block;
  margin: 0px 20px 10px 0px;
  /*float: left;*/
  position: relative;
  /*overflow: hidden;*/
  &:last-child {
    margin: 0px 0px 10px;
  }
}
.movieImage.rank {
  position: absolute;
  right: 0;
}
.movieImage.host {
  width: 256px;
}
.movieImage.rank.host {
  width: 192px;
}
.movieImage.boutique:first-child {
  width: 512px;
}
.movieImage.boutique:not(:first-child) {
  width: 192px;
}

.searchPageImageList > .imageList > .content {
  .movieImage.free,
  .movieImage.vip,
  .movieImage.comedy {
    width: 15%;
    margin-right: 1.6%;
  }
}

.movieList > .imageList > .content {
  .movieImage.free,
  .movieImage.vip,
  .movieImage.comedy {
    width: 192px;
  }
}

.movieImage.special {
  width: 256px;
}
.movieImage.guess {
  width: 256px;
}
.img {
  position: relative;
}
.img > img {
  width: 100% !important;
  height: 100% !important;
}
.movieImage > div > .img {
  cursor: pointer;
}
.movieImage.host > div > .img {
  width: 256px;
  height: 144px;
}
.movieImage.boutique:first-child > div > .img {
  width: 512px;
  height: 288px;
}
.movieImage.boutique:not(:first-child) > div > .img {
  width: 192px;
  height: 288px;
}

.movieList > .content > .imageList {
  .movieImage.free > div > .img,
  .movieImage.vip > div > .img,
  .movieImage.comedy > div > .img {
    width: 192px;
    height: 288px;
  }
}
.searchPageImageList > .content > .imageList {
  .movieImage.free > div > .img,
  .movieImage.vip > div > .img,
  .movieImage.comedy > div > .img {
    width: 100%;
    height: 100%;
  }
}
.movieImage.special > div > .img {
  width: 256px;
  height: 144px;
}
.movieImage.guess > div > .img {
  width: 256px;
  height: 144px;
}
.introduce {
  padding-top: 10px;
  position: relative;
}
.movieIntro,
.movieName {
  display: block;
}
.movieName {
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  line-height: 22px;
  height: 22px;
}
.movieName:hover,
li:hover {
  color: #1fafc0;
}
.movieIntro {
  margin-top: 2px;
  font-size: 15px;
  color: #999;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 40px;
  height: 40px;
}
.grade {
  position: absolute;
  top: 8px;
  right: 10px;
  font-size: 23px;
  color: #ff1e13;
  font-weight: 700;
}
</style>

<script>
/* 组件引入 */
import Seniority from "./seniority.vue";

export default {
  props: {
    info: Object,
  },
  components: { Seniority },
  watch: {
    "info.type": function () {
      this.getInit();
    },
  },
  data() {
    return {
      moreClass: "",
      sHrefText: "",
      isContent: "",
      list: "",
      movieImg: "",
      mainList: [],
    };
  },
  created() {
    this.getInit();
    if (this.info.isSeniority) {
      this.mainList = this.info.list.slice(0, 4);
    } else {
      this.mainList = this.info.list.slice(0, 5);
    }
  },
  methods: {
    getInit() {
      var info = this.info;

      var moreClass = "";

      var sHrefText = "";

      var movieImg = "";

      var list = info.list || [];

      var isContent = false;

      switch (info.type) {
        case "host": // 电影热播榜
          moreClass = "vip";
          // sHrefText = 'VIP专享影视排行'
          sHrefText = "更多";
          movieImg = "host";
          isContent = true;
          break;
        case "boutique": // 精品推荐
          moreClass = "";
          sHrefText = "更多";
          movieImg = "boutique";
          isContent = true;
          break;
        case "free": // 免费电影
          moreClass = "";
          sHrefText = "更多";
          movieImg = "free";
          isContent = true;
          break;
        case "vip": // 会员专享
          moreClass = "";
          sHrefText = "更多";
          movieImg = "vip";
          isContent = true;
          break;
        case "comedy": // 爆笑喜剧
          moreClass = "";
          sHrefText = "更多";
          movieImg = "comedy";
          isContent = true;
          break;
        case "special": // 电影专题
          moreClass = "";
          sHrefText = "更多";
          movieImg = "special";
          isContent = false;
          break;
        case "guess": // 猜你喜欢
          moreClass = "";
          sHrefText = "";
          movieImg = "guess";
          isContent = true;
          break;
      }
      if (info.titleBtn) {
        sHrefText = info.titleBtn;
      }

      this.moreClass = moreClass;
      this.sHrefText = sHrefText;
      this.isContent = isContent;
      this.list = list;
      this.movieImg = movieImg;
    },
    // 点击更多按钮回调
    moreClick(info) {
      this.$emit("moreClick", info);
    },
    // 点击电影模块回调  参数： infoItem - object - 被点击电影的数据对象
    movieClick(infoItem, info) {
      this.$emit("movieClick", { infoItem: infoItem, info: info });
    },
    seniorityClick(infoItem) {
      this.$emit("movieClick", { infoItem: infoItem, info: this.info });
    },
    // 点击右侧按钮回调  参数： btnInfo - object - 被点击的按钮对象
    btnClick(btnInfo) {
      this.$emit("btnClick", btnInfo);
    },
  },
};
</script>
